import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {AddAttachedDialogComponent} from '../components/add-attached-dialog/add-attached-dialog.component';
import {Observable} from 'rxjs/Observable';
import {RemoveFileDialogComponent} from '../components/remove-file-dialog/remove-file-dialog.component';
import {AttachedFile} from '../models/attached-file.model';
import {UploadFileService} from '../service/upload-file.service';
import {Utilities} from './utilities.model';
import {DeliveryUtilities} from '../../delivery/utilities/delivery-utilities.model';
import {Alert} from '../../delivery/models/alert.model';
import {AlertModel} from '../../notification-center/models/alert.model';
import { zip } from 'rxjs';

export class AddAttachedFileUtilitiesModel {

	static openAddAttachedDialog(dialog: MatDialog, commodities: number[], resource_type: string, resource_id: any, blob_type: string,  params?: any): Observable<any> {
		const dialogRef: MatDialogRef<AddAttachedDialogComponent> = dialog.open(AddAttachedDialogComponent, {
            height: 'auto',
			width: '600px',
			panelClass: 'amd-full-screen-simple-table-dialog',
			disableClose: true,
			position: {top: '20px'}
		});


		dialogRef.componentInstance.commoditiesID = commodities;
		dialogRef.componentInstance.resource_type = resource_type;
		dialogRef.componentInstance.resource_id = resource_id;
		dialogRef.componentInstance.blob_type = blob_type;

		if (!Utilities.isVoid(params) && !Utilities.isVoid(params.context)) {
			dialogRef.componentInstance.context = params.context;
		}

		if (!Utilities.isVoid(params) && !Utilities.isVoid(params.limit)) {
			dialogRef.componentInstance.limit = params.limit;
		}

		if (!Utilities.isVoid(params) && !Utilities.isVoid(params.allowed_extensions)) {
			dialogRef.componentInstance.allowed_extensions = params.allowed_extensions;
		}

		if (!Utilities.isVoid(params) && !Utilities.isVoid(params.preLoadAttachments)) {
			dialogRef.componentInstance.preLoadAttachments = params.preLoadAttachments;
		}

        if (!Utilities.isVoid(params) && !Utilities.isVoid(params.tyre_attachment_type)) {
            dialogRef.componentInstance.tyre_attachment_type = params.tyre_attachment_type;
        }

        if (!Utilities.isVoid(params) && !Utilities.isVoid(params.tyre_transfer_uuid)) {
            dialogRef.componentInstance.tyre_transfer_uuid = params.tyre_transfer_uuid;
        }

        if (!Utilities.isVoid(params) && !Utilities.isVoid(params.tyre_transfer_tyre_uuid)) {
            dialogRef.componentInstance.tyre_transfer_tyre_uuid = params.tyre_transfer_tyre_uuid;
        }

		return dialogRef.afterClosed();
	}

	static confirmDeleteFileDialog(dialog: MatDialog, file_name: string, description: string): Observable<any> {
		const dialogRef: MatDialogRef<RemoveFileDialogComponent> = dialog.open(RemoveFileDialogComponent, {
			height: 'auto',
			width: '600px',
			position: {top: '100px'}
		});

		dialogRef.componentInstance.fileName = file_name;
		dialogRef.componentInstance.description = description;

		return dialogRef.afterClosed();
	}

	static uploadFile(uploadFileService: UploadFileService, file: AttachedFile, resource_id: any): Observable<boolean> {
		file.resource_id = resource_id;
		return new Observable<boolean>(observer => {
			uploadFileService.uploadFile(file).subscribe(
				resp => {
					if (!Utilities.isVoid(file)) {
						file.file_content = null;
					}
					if (!Utilities.isVoid(resp) && resp.status === 201) {
						file.uuid = resp.json().uuid;
						file.blob_name = resp.json().blob_name;
						file.created_at = resp.json().created_at;
						observer.next(true);
					} else {
						observer.next(false);
					}
				}, error => {
					observer.next(false);
				});
		});
	}

	static uploadFilesForAlert(uploadFileService: UploadFileService, files: AttachedFile[], alert: Alert): Observable<boolean> {
		return new Observable<boolean>(observer => {
			if (Utilities.isVoid(files) || files.length === 0) {
				observer.next(true);
			} else {
				const requests = [];
				files.forEach((file) => {
					requests.push(AddAttachedFileUtilitiesModel.uploadFile(uploadFileService, file, alert.id_message_ext));
				});
				zip(...requests).subscribe(
					(resps: any[]) => {
						let allFilesUploaded = true;
						for (let i = 0; i < resps.length; i++) {
							if (!Utilities.isVoid(resps[i]) && resps[i]) {
								alert.addAttached(DeliveryUtilities.getDeliveryAttachedBody(files[i]));
							} else {
								allFilesUploaded = false;
							}
						}
						observer.next(allFilesUploaded);
					}, error => {
						observer.next(false);
					});
			}
		});
	}

	static uploadFilesForNewAlert(uploadFileService: UploadFileService, files: AttachedFile[], alert: any): Observable<boolean> {
		return new Observable<boolean>(observer => {
			if (Utilities.isVoid(files) || files.length === 0) {
				observer.next(true);
			} else {
				const requests = [];
				files.forEach((file) => {
					requests.push(AddAttachedFileUtilitiesModel.uploadFile(uploadFileService, file, alert.alert_id));
				});
				zip(...requests).subscribe(
					(resps: any[]) => {
						let allFilesUploaded = true;
						for (let i = 0; i < resps.length; i++) {
							if (!Utilities.isVoid(resps[i]) && resps[i]) {
								alert.addAttached(files[i]);
							} else {
								allFilesUploaded = false;
							}
						}
						observer.next(allFilesUploaded);
					}, error => {
						observer.next(false);
					});
			}
		});
	}
}
